/**
 * Mag set top box new api polyfill for stbPlayerManeger
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>
 */

'use strict';

// disable eslint
/*eslint-disable*/

var stbPlayerManager,
    stbPlayer = {},
    gSTB = window.parent.gSTB,
    stbDisplayManager = require('./stbDisplayManager'),
    _dolbyDigitalAudioMode = 0,
    _enableSubtitles = false,
    _subtitlesColor = 0xffffff,
    _subtitlesEncoding = 'UTF-8',
    _subtitlesFont = '',
    _subtitlesOffset = 0,
    _subtitlesSize = 20,
    _aspectConversion = 0,
    _viewport = {
        height: screen.height,
        width: screen.width,
        x: 0,
        y: 0
    },
    _clip = {
        height: 0,
        save: false,
        width: 0,
        x: 0,
        y: 0

    },
    _fullscreen = true,
    _enableTeletext = false,
    _teletextVisible = false,
    _loop = false,
    _enablePopup = true,
    _visible = true,
    _teletextOpacity = 0,
    _teletextViewport = {
        x:0, y:0, width:0, height: 0
    },
    _timeShiftFolder,
    _timeShiftMaxDuration = 0,
    _timeShiftSlidingMode = false,
    _checkSSLCertificate = true,
    _audioPrimaryLanguage,
    _audioSecondaryLanguage,
    _subtitlesSecondaryLanguage,
    _subtitlesPrimaryLanguage,
    casParams = {},
    webCasParams = {}
    ;

if ( window.parent.stbPlayerManager ) {
// if ( false ) {
    module.exports = window.parent.stbPlayerManager;
} else {
    /**
     * Stb event events
     */
    // hack for develop
    if ( DEVELOP ) {
        window.parent.stbEvent.events.media = [];
    }
    window.parent.stbEvent.addListener('media', function (event) {
        switch ( event.code ) {
            case 1:
                // idle
                stbPlayer.state = 0;
                if ( stbPlayer.onPlayEnd ) { stbPlayer.onPlayEnd(); }
                break;
            case 2:
                getMediaInfo();
                if ( stbPlayer.onTracksInfo ) { stbPlayer.onTracksInfo(); }
                break;
            case 4:
                // currently is playing
                stbPlayer.state = 2;
                if ( stbPlayer.onPlayStart ) { stbPlayer.onPlayStart(); }
                break;
            case 5:
                // idle
                stbPlayer.state = 0;
                if ( stbPlayer.onPlayError ) { stbPlayer.onPlayError(); }
                break;
            case 6:
                if ( stbPlayer.onDualMono ) { stbPlayer.onDualMono(); }
                break;
            case 7:
                getVideoInfo();
                if ( stbPlayer.onContentInfo ) { stbPlayer.onContentInfo(); }
                break;
            case 8:
                if ( stbPlayer.onTracksError ) { stbPlayer.onTracksError(); }
                break;
            case 9:
                if ( stbPlayer.onTracksUpdate ) { stbPlayer.onTracksUpdate(); }
                break;
            case 129:
                if ( stbPlayer.onRTPBreak ) { stbPlayer.onRTPBreak(); }
                break;
            }
    });


    stbPlayer = {

            /**
             * A surface linked with this player.
             *
             * @type {stbSurface}
             * @readonly
             */
            surface: {
                moveTop: function () {
                    gSTB.SetTopWin(1);
                },
                moveDown: function () {
                    gSTB.SetTopWin(0);
                }
            },

            /**
             * Clear player statistics.
             *
             * @see stbPlayer.statistics}.
             */
            clearStatistics: function () {
                this.statistics = {
                    continuityErrors: 0,
                    decodingErrors: 0,
                    rtpErrors: 0
                };
            },


            /**
             * Get the list of audio tracks in the stream.
             *
             * This property should be accessed after the `event 2` occurs (see description of events).
             *
             * @type {audioTrackConfig[]}
             * @readonly
             *
             * @example
             * // 2 audio tracks in the stream:
             * // Russian AC3 having PID 114 and English mp3 having PID 115
             * [
             *     {
                     *         pid: 114,
                     *         lang: ['rus', 'ru'],
                     *         type: 3,
                     *         title: 'Description'
                     *     },
             *     {
                     *         pid: 115,
                     *         lang: ['eng', ''],
                     *         type: 2,
                     *         title: 'Description'
                     *     }
             * ]
             */
            audioTracks: [],


            /**
             * Get the list of subtitles tracks in the stream.
             *
             * This property should be accessed after the `event 2` occurs (see description of events).
             *
             * @type {subtitlesTrackConfig[]}
             * @readonly
             *
             * @example
             * // 2 subtitles tracks in the stream:
             * // Russian AC3 having PID 114 and English having PID 115
             * [
             *     {
                     *         pid: 114,
                     *         lang: ['rus', 'ru']
                     *     },
             *     {
                     *         pid: 115,
                     *         lang: ['eng', ''],
                     *         teletextPage: 250,
                     *         type: 'graphic' // or 'text'
                     *     }
             * ]
             */
            subtitlesTracks: [],


            /**
             * Show text string as a subtitle on screen.
             *
             * In case when `start` and `end` equal 0 or not set, text is shown on screen immediately until next {@link stbPlayer.printSubtitle} is called or 30 seconds elapsed.
             *
             * If this function was called then subtitles will work only via {@link stbPlayer.printSubtitle} until next call of {@link stbPlayer.play}.
             *
             * @param {string} text this text will be shown on screen as a subtitle
             * @param {number} [start] string presentation start time in ms from start of current media
             * @param {number} [end] string presentation end time in ms from start of current media
             */
            drawSubtitle: function ( text, start, end ) {
                gSTB.ShowSubtitle(start, end, text);

            },


            /**
             * Load text subtitles from external subtitle file of srt, sub, ass formats.
             *
             * If subtitles are loaded successfully then external subtitle track will be added to subtitle track list with number(PID) 0x2000.
             *
             * If any error occurs while loading subtitles then JS API user will receive `event 8` from List of the events used.
             *
             * @param {string} url external subtitles address
             *
             * can be a local URL: `/media/USB-.../subtitles.srt` and URL from HTTP server: `http://192.168.1.1/subtitles.srt`
             */
            loadExternalSubtitles: gSTB.LoadExternalSubtitles,


            /**
             * Current state of player.
             *
             *  Value | Description
             * -------|-------------
             *  0     | idle
             *  1     | opening (between {@link stbPlayer.play} method call and `event 4`)
             *  2     | currently is playing
             *  3     | paused
             *
             * @type {number}
             * @readonly
             */
            state: 0,


            /**
             * Get bitrate information of currently played HLS stream.
             *
             * Fields:
             *
             *  Name           | Description
             * ----------------|-------------
             *  currentBitrate | currently active bitrate
             *  bitrateList    | list of all bitrates in a strem and can be empty (available only for Apple HLS streams)
             *
             * @type {Object}
             *
             * @example
             * {
                     *     currentBitrate: 533981,
                     *     bitrateList: [323613, 533981, 755232, 1384811, 2020273]
                     * }
             */
            HLSInfo: null,


            /**
             * Get metadata information stored in current content.
             * For example, it can be data from ID3 tag from mp3 file.
             *
             * It's better to request this information after getting `event 2` from list of the events used.
             *
             * @type {Object}
             *
             * @example
             * {
                     *     album: "album_1",
                     *     album_artist: "artist_1",
                     *     artist: "artist_1",
                     *     comment: "",
                     *     composer: "",
                     *     copyright: "",
                     *     date: "2000",
                     *     disc: "",
                     *     encoder: "",
                     *     encoded_by: "",
                     *     filename: "",
                     *     genre: "",
                     *     language: "",
                     *     performer: "",
                     *     publisher: "publisher_1",
                     *     title: "track_9",
                     *     track: "9"
                     * }
             */
            metadataInfo: null,


            /**
             * Get information about current video content.
             *
             * This property should be used after receiving `event 7` from list of the events used.
             *
             * Available fields:
             *
             *  Name          | Description
             * ---------------|-------------
             *  frameRate     | video frame rate
             *  width         | encoded video width
             *  height        | encoded video height
             *  hPAR and vPAR | horizontal and vertical pixel aspect ratio coefficients <br> in example these params mean that movie aspect ratio is: (704*hPAR/vPAR)/576 = 1.333333333(3) = 4:3 for square pixels
             *
             * @type {Object}
             *
             * @example
             * {
                     *     frameRate: 25000,
                     *     width: 704,
                     *     height: 576,
                     *     hPAR: 12,
                     *     vPAR: 11
                     * }
             */
            videoInfo: null,


            /**
             * Apply video surface position and size in pixels and clipping rectangle for input video.
             *
             * It's possible to set only some properties (not all of them at once).
             *
             * @see stbPlayer.viewport
             * @see stbPlayer.clip
             *
             * @param {viewportConfig} viewport video surface position and size
             * @param {clipConfig} [clip] optional clipping rectangle for input video
             *
             * @example
             * // full setup
             * stbPlayer.setViewport(
             *     {
                     *         x: 0,
                     *         y: 0,
                     *         width: 1280,
                     *         height: 720
                     *     },
             *     {
                     *         x: 10,
                     *         y: 10,
                     *         width: 1260,
                     *         height: 700,
                     *         save: true
                     *     }
             * );
             *
             * @example
             * // partial setup
             * // move video rectangle 100 px left
             * stbPlayer.setViewport({x: 100});
             * // resize video rectangle only horizontally
             * stbPlayer.setViewport({width: 500});
             */
            setViewport: function ( viewport, clip ) {
                //xSize, ySize, xPos, yPos, clipXSize, clipYSize, clipXPos, clipYPos, saveClip
                clip = clip || {
                        x:0,
                        y:0,
                        width:screen.width,
                        height:screen.height
                    };
                gSTB.SetViewportEx(viewport.width, viewport.height, viewport.x, viewport.y, clip.width, clip.height, clip.x, clip.y);
                _viewport = {
                    width: viewport.width,
                    height: viewport.height,
                    x: viewport.x,
                    y: viewport.y
                };
            },


            /**
             * Start playing the given media content.
             *
             * @param {playConfig} config content playback options
             */
            play: function ( config ) {
                gSTB.Play((config.solution || 'auto') + ' ' + config.uri, config.proxy);

                // opening (between {@link stbPlayer.play} method call and `event 4`)
                stbPlayer.state = 1;
            },


            /**
             * Stop playing.
             *
             * {@link stbPlayer.resume} shall begin playing from the beginning.
             */
            stop: function () {
                gSTB.Stop();
            },


            /**
             * Pause current playback.
             *
             * {@link stbPlayer.resume} continues playing from the current position.
             */
            pause: function () {
                gSTB.Pause();
                // paused
                stbPlayer.state = 3;
            },


            /**
             * Continue playing (after {@link stbPlayer.pause})
             * or begin anew (after {@link stbPlayer.stop}).
             */
            resume: function () {
                gSTB.Continue();
                // currently is playing
                stbPlayer.state = 2;
            },


            /**
             * Rotate player but *works only for images.*
             *
             * @param {number} angle rotates the video window contents by the preset angle relative to the initial position
             *
             * allowed values: 0, 90, 180, 270.
             */
            rotate: function ( angle ) {
                gSTB.Rotate(angle);
            },


            /**
             * The player reached the end of the media content or detected a discontinuity of the stream.
             *
             * @see {@link stbEvent.onEvent} (event 1)
             */
            onPlayEnd: function () {},


            /**
             * Information on audio and video tracks of the media content is received.
             * It's now possible to call {@link stbPlayer.audioTracks} etc.
             *
             * @see {@link stbEvent.onEvent} (event 2)
             */
            onTracksInfo: function () {},


            /**
             * The decoder has received info about the content and started to play.
             * It's now possible to call {@link stbPlayer.videoInfo}.
             *
             * @see {@link stbEvent.onEvent} (event 7)
             */
            onContentInfo: function () {},


            /**
             * Video/audio playback has begun.
             *
             * @see {@link stbEvent.onEvent} (event 4)
             */
            onPlayStart: function () {},


            /**
             * Error when opening the content: content not found on the server or connection with the server was rejected.
             *
             * @see {@link stbEvent.onEvent} (event 5)
             */
            onPlayError: function () {},


            /**
             * Error occurred while loading external subtitles.
             *
             * @see {@link stbEvent.onEvent} (event 8)
             */
            onTracksError: function () {},


            /**
             * Detected DualMono AC-3 sound.
             *
             * @see {@link stbEvent.onEvent} (event 6)
             */
            onDualMono: function () {},


            /**
             * Found new teletext or subtitles in stream.
             *
             * @see {@link stbEvent.onEvent} (event 9)
             */
            onTracksUpdate: function () {},


            /**
             * Found new teletext or subtitles in stream.
             *
             * @see {@link stbEvent.onEvent} (event 129)
             */
            onRTPBreak: function () {},


            /**
             * TimeShift external protocol event.
             *
             * @see {@link timeShift}
             * @see {@link stbEvent.onEvent} (event 36)
             *
             * @param {number} code TimeShift event code
             *
             *  Code | Description
             * ------|-------------
             *  1    | Start playing.
             *  2    | Stop playing.
             *  3    | SetSlidingMode(1), when playback was in timeshift mode on pause and current position differs from realtime position more that on maximum buffer duration of timeshift. If in pause mode event 3 appeared, then it is necessary to send resume.
             *  4    | When timeshift buffer is full. After this event in SetSlidingMode(0) mode, new data are lost and navigation is available only in buffer or switch to real time mode (saving with resume is impossible). Event 4 while SetSlidingMode(1) means that timeshift buffer is full and old data will start to erase itself.
             *  5    | Comes before 1 minute before buffer turns full (1 minute before event 4).
             *  6    | Comes while playback if storage device is not available (data=1) or there is no free space (data=2). After this event playback will automaticly switch in real time.
             *
             * @param {string} data event specific info
             */
            onTimeShift: function ( code, data ) {}, // TODO


            /**
             * Get the list of teletext tracks in the stream.
             *
             * This property should be accessed after the `event 9` occurs (see description of events).
             *
             * @type {teletextTracksConfig[]}
             * @readonly
             *
             * @example
             * // 2 teletext tracks in the stream:
             * // Russian AC3 having PID 114 and English having PID 115
             * [
             *     {
                     *         pid: 114,
                     *         lang: ['rus', 'ru']
                     *     },
             *     {
                     *         pid: 115,
                     *         lang: ['eng', '']
                     *     }
             * ]
             */
            teletextTracks: [],


            /**
             * Apply teletext viewport position and size.
             *
             * @param {viewportConfig} teletext viewport position and size
             */
            setTeletextViewport: function ( config ) {
                gSTB.setTeletextViewport(config.width, config.height, config.x, config.y);
                _teletextViewport = {
                    width: config.width || _teletextViewport.width,
                    height: config.height || _teletextViewport.height,
                    x: config.x || _teletextViewport.x,
                    y: config.y || _teletextViewport.y
                }
            },


            /**
             * Run teletext command.
             *
             * @param {number} command possible values:
             *
             *  Value | Description
             * -------|-------------
             *  0     | digit 0
             *  1     | digit 1
             *  2     | digit 2
             *  3     | digit 3
             *  4     | digit 4
             *  5     | digit 5
             *  6     | digit 6
             *  7     | digit 7
             *  8     | digit 8
             *  9     | digit 9
             *  10    | NextPage
             *  11    | PrevPage
             *  12    | NextSubpage
             *  13    | PrevSubpage
             *  14    | Red
             *  15    | Yellow
             *  16    | Blue
             *  17    | Green
             */
            teletextCommand: function ( command ) {
                gSTB.TeletextCommand(command);
            },


            /**
             * Set the default encoding which will be used to display teletext channel if no such information in teletext stream.
             *
             * @param {teletextCharsetConfig} charset encoding for teletext channel
             * @param {boolean} auto set encoding to auto mode, if true - `charset` param will be ignored
             */
            defaultTeletextSubtitlesCharset: gSTB.DefaultTtxSubCharset,


            /**
             * Set the encoding which will be forced to display teletext channel.
             *
             * @param {teletextCharsetConfig} charset encoding for teletext channel
             * @param {boolean} auto set encoding to auto mode, if true - `charset` param will be ignored
             */
            forceTeletextSubtitlesCharset: gSTB.ForceTtxSubCharset,

            /**
             * TimeShift run-time state.
             *
             * @type {number} possible values:
             *
             *  Value | Description
             * -------|-------------
             *  0     | not active
             *  1     | active
             *  2     | error
             */
            timeShiftState: 0,

            /**
             * Enter TimeShift mode.
             *
             * In this mode trick mode commands like pause, resume, seek is allowed.
             *
             * @see timeShift.EnterTimeShift
             */
            timeShiftStart: function (  ) {},


            /**
             * Exit from TimeShift mode and return to real-time mode (with no arguments).
             * Exit from TimeShift mode and save current TimeShift buffer via PVR (with `path` and `name` arguments).
             * Exit from TimeShift, stop playback and save TimeShift buffer via PVR with possibility to continue recording (with all arguments).
             *
             * @see timeShift.ExitTimeShift
             * @see timeShift.ExitTimeShiftAndSave
             * @see timeShift.ExitTimeShiftAndSaveDuration
             *
             * @param {string} [path] path to location where recording will be saved
             * @param {string} [name] name of the recording
             * @param {number} [duration] in second for how log PVR should continue to save stream into specified recording task
             */
            timeShiftStop: function ( path, name, duration ) {
                /*if ( arguments.length === 0 ) {
                 timeShift.ExitTimeShift();
                 } else if ( arguments.length === 2 ) {
                 timeShift.ExitTimeShiftAndSave(path, name);
                 }*/
            }

        };

    Object.defineProperties(stbPlayer, {
        /**
         * Get run-time player capabilities.
         *
         * @type {capabilitiesConfig}
         * @readonly
         */
        'capabilities': {
            value:{
                audio: true,
                autoFrameRate: true,
                subtitles: true,
                teletext: true,
                video: true
            }
        },


        /**
         * Get player statistics.
         *
         * @see stbPlayer.clearStatistics
         *
         * @type {statisticsConfig}
         * @readonly
         *
         * @example
         * // output video decoding error count
         * console.log(stbPlayer.statistics.decodingErrors);
         */
        'statistics': {
            value:{
                continuityErrors: 0,
                decodingErrors: 0,
                rtpErrors: 0
            }
        },


        /**
         * Mute state of audio output.
         *
         * This is a combination of master mute state (see {@link stbAudioOutput.mute}) and local player state.
         *
         * After the cycle of switching off/on with this property the volume level remains unchanged.
         *
         * @type {boolean}
         */
        'mute': {
            get: function () {
                return gSTB.GetMute();
            },
            set: function ( val ) {
                gSTB.SetMute(!!val);
            }
        },


        /**
         * Current volume level in percents (0 - no sound, 100 - maximal level).
         *
         * This is a combination of master volume level (see {@link stbAudioOutput.volume}) and local player volume level.
         *
         * @type {number}
         */
        'volume': {
            get: function () {
                return gSTB.GetVolume();
            },
            set: function ( val ) {
                gSTB.SetVolume(+val);
            }
        },


        /**
         * Number (PID) of the current audio track [0..0x1fff].
         *
         * This property should be accessed after the `event 2` occurs (see description of events).
         *
         * On set if a specified track is absent the sound is disabled.
         *
         * The list of all audio tracks determined by the player can be received with {@link stbPlayer.audioTracks}.
         *
         * @type {number}
         */
        'audioPID': {
            get: function () {
                return gSTB.GetAudioPID();
            },
            set: function ( val ) {
                gSTB.SetAudioPID(val);
            }
        },


        /**
         * Operational Mode for DolbyDigital audio.
         *
         * Affects only DolbyDigital audio.
         *
         * Possible values:
         *
         *  Value | Description
         * -------|-------------
         *  0     | RF mode
         *  1     | Line mode
         *  2     | Custom0
         *  3     | Custom1
         *
         * @type {number}
         */
        'dolbyDigitalAudioMode': {
            set: function ( val ) {
                gSTB.SetAudioOperationalMode(+val);
                _dolbyDigitalAudioMode = +val;
            },
            get: function () {
                return _dolbyDigitalAudioMode;
            }
        },


        /**
         * Activate/deactivate subtitles output.
         *
         * For MAG100 subtitles are displayed only in full screen mode.
         *
         * @type {boolean}
         */
        'enableSubtitles': {
            get: function () {
                return _enableSubtitles;
            },
            set: function ( val ) {
                gSTB.SetSubtitles(!!val);
                _enableSubtitles = !!val;
            }
        },


        /**
         * Number (PID) of the current subtitles track [0..0x1fff].
         *
         * This property should be accessed after the `event 2` occurs (see description of events).
         *
         * The list of all subtitles track determined by the player can be received with {@link stbPlayer.subtitlesTracks}.
         *
         * @type {number}
         */
        'subtitlesPID': {
            get: function () {
                return gSTB.GetSubtitlePID();
            },
            set: function ( val ) {
                gSTB.SetSubtitlePID(val);
            }
        },


        /**
         * Subtitles color in RGB format.
         *
         * @type {number}
         * @default 0xffffff
         *
         * @example
         * // set red color for text subtitles
         * stbPlayer.subtitlesColor = 0xff0000;
         */
        'subtitlesColor': {
            get: function () {
                return _subtitlesColor;
            },
            set: function ( val ) {
                gSTB.SetSubtitlesColor(val);
                _subtitlesColor = val;
            }
        },


        /**
         * Encoding which will be used to display external subtitles.
         *
         * For example: "utf-8", "cp1250", "cp1251", ..., "cp1258", "iso8859-1", ..., "iso8859-16"
         *
         * @type {string}
         * @default UTF-8
         */
        'subtitlesEncoding': {
            get: function () {
                return _subtitlesEncoding;
            },
            set: function ( val ) {
                gSTB.SetSubtitlesEncoding(val);
                _subtitlesEncoding = val;
            }
        },


        /**
         * Font filename for displaying text subtitles.
         *
         * For example: '/home/default/arial.ttf'.
         *
         * @type {string}
         */
        'subtitlesFont': {
            get: function () {
                return _subtitlesFont;
            },
            set: function ( val ) {
                gSTB.SetSubtitlesFont(val);
                _subtitlesFont = val;
            }
        },


        /**
         * Horizontal offset for displaying text subtitles.
         *
         * @type {number}
         */
        'subtitlesOffset': {
            get: function () {
                return _subtitlesOffset;
            },
            set: function ( val ) {
                gSTB.SetSubtitlesOffs(val);
                _subtitlesOffset = val;
            }
        },


        /**
         * Size of text subtitles (in pixels).
         *
         * @type {number}
         * @default 20
         */
        'subtitlesSize': {
            get: function () {
                return _subtitlesSize;
            },
            set: function ( val ) {
                gSTB.SetSubtitlesSize(+val);
                _subtitlesSize = +val;
            }
        },


        /**
         * Get the current buffer loading in percents [0..100].
         *
         * It makes sense to call this function only with the following solutions:
         * **ffmpeg**, **ffrt**, **ffrt2**, **ffrt3**, **fm**, **file**
         * after getting `event 2` and before complete buffer filling or before getting `event 4`.
         *
         * @type {number}
         * @readonly
         */
        'bufferLoad': {
            get: function () {
                return gSTB.GetBufferLoad();
            }
        },


        /**
         * Total length of the current content in seconds.
         *
         * @type {number}
         */
        'duration': {
            get: function () {
                return gSTB.GetMediaLen();
            }
        },


        /**
         * Total length of the current content in milliseconds.
         *
         * @type {number}
         */
        'durationMs': {
            get: function () {
                return gSTB.GetMediaLenEx();
            }
        },


        /**
         * Current media position from the beginning of content in seconds.
         *
         * @type {number}
         */
        'position': {
            get: function () {
                return gSTB.GetPosTime();
            },
            set: function ( val ) {
                gSTB.SetPosTime(val);
            }
        },


        /**
         * Current media position from the beginning of content in milliseconds.
         *
         * @type {number}
         */
        'positionMs': {
            get: function () {
                return gSTB.GetPosTimeEx();
            },
            set: function ( val ) {
                gSTB.SetPosTimeEx(val);
            }
        },


        /**
         * Current media position from the beginning of content in percents with fraction part.
         *
         * @type {number}
         *
         * @example
         * // position is 50% and a half of a percent
         * 50.5
         */
        'positionPercent': {
            get: function () {
                return gSTB.GetPosPercent();
            },
            set: function ( val ) {
                gSTB.SetPosPercent(val);
            }
        },


        /**
         * Playback repeat mode.
         *
         * @type {boolean}
         */
        'loop': {
            get: function () {
                return _loop;
            },
            set: function ( val ) {
                gSTB.SetLoop(val);
            }
        },


        /**
         * Current speed of playing.
         *
         * @type {number} possible values:
         *
         *  Value | Description
         * -------|-------------
         *  0.25  | quarter speed
         *  0.5   | half speed
         *  1     | normal
         *  2     | 2x
         *  4     | 4x
         *  8     | 8x
         *  12    | 12x
         *  16    | 16x
         *  32    | 32x
         *  64    | 64x
         *  -0.25 | backward quarter speed
         *  -0.5  | backward half speed
         *  -1    | backward normal
         *  -2    | backward 2x
         *  -4    | backward 4x
         *  -8    | backward 8x
         *  -12   | backward 12x
         *  -16   | backward 16x
         *  -32   | backward 32x
         *  -64   | backward 64x
         */
        'speed': {
            get: function () {
                return gSTB.GetSpeed();
            },
            set: function ( val ) {
                gSTB.SetSpeed(val);
            }
        },


        /**
         * Video format conversion.
         *
         *  Value | Description
         * -------|-------------
         *  0     | as it is (video is stretched for the whole screen)
         *  1     | Letter box mode (video is proportionally enlarged to the size of the screen along the larger edge)
         *  2     | Pan&Scan mode (video is proportionally enlarged to the screen size along the lesser edge)
         *  3     | combined mode (intermediate between Letter Box Box and Pan&Scan)
         *  4     | enlarged mode
         *  5     | optimal mode
         *
         * Player uses this property only in fullscreen mode (see {@link stbPlayer.pig} and {@link stbPlayer.setPIG}).
         *
         * @type {number}
         */
        'aspectConversion': {
            get: function () {
                return _aspectConversion;
            },
            set: function ( val ) {
                var a = '0x' + val + '0';
                gSTB.SetAspect(a);
                _aspectConversion = val;
            }
        },


        /**
         * Get video surface position and size.
         *
         * @see stbPlayer.setViewport
         *
         * @type {viewportConfig}
         * @readonly
         */
        'viewport': {
            get: function () {
                return _viewport;
            }
        },


        /**
         * Get clipping rectangle for input video.
         *
         * @see stbPlayer.setViewport
         *
         * @type {clipConfig}
         * @readonly
         */
        'clip': {
            get: function () {
                return _clip;
            }
        },

        /**
         * Video window state (show the video in the specified rectangle or fullscreen).
         *
         * Works only to switch from non-fullscreen mode to fullscreen.
         *
         * @type {boolean}
         */
        'fullscreen': {
            get: function () {
                return _fullscreen;
            },
            set: function ( val ) {
                if ( val === true ) {
                    gSTB.SetPIG(1,0,0,0);
                    _fullscreen = true;
                    _viewport = {
                        x:0,
                        y:0,
                        width: stbDisplayManager.list[0].width,
                        height: stbDisplayManager.list[0].height
                    };
                }
            }
         },


        /**
         * Enable/disable teletext.
         *
         * @type {boolean}
         * @default false
         */
        'enableTeletext': {
            get: function () {
                return _enableTeletext;
            },
            set: function ( val ) {
                gSTB.SetTeletext(val);
                _enableTeletext = val;
            }
        },

        /**
         * Show/hide teletext.
         *
         * @type {boolean}
         * @default false
         */
        teletextVisible: {
            get: function () {
                return _teletextVisible;
            },
            set: function ( val ) {
                gSTB.TeletextShow(val);
                _teletextVisible = val;
            }
        },
        /**
         * Video window control mode.
         *
         * If `true` the device automatically switches on the video window at the beginning of playing and switches it off when stops.
         * Otherwise API user should use {@link stbPlayer.visible} for instructing whether to show the video window or not.
         *
         * @type {boolean}
         */
        enablePopup: {
            get: function () {
                return _enablePopup;
            },
            set: function ( val ) {
                val = !!val;

                if ( val ) {
                    gSTB.SetVideoControl(0);
                } else {
                    gSTB.SetVideoControl(1);
                }
                _enablePopup = val;
            }
        },


        /**
         * Video window visibility.
         *
         * If `true` video window is displayed (in case the stream is present).
         *
         * Valid only if user control had been allowed with {@link stbPlayer.enablePopup}.
         *
         * @type {boolean}
         */
        visible: {
            get: function () {
                return _visible;
            },
            set: function ( val ) {
                val = !!val;
                _visible = val;
                gSTB.SetVideoState(val);
            }
        },
        /**
         * Setup opacity level for teletext [0 .. 1].
         *
         * @type {number}
         * @default 1
         *
         * @example
         * // normal teletext
         * stbPlayer.teletextOpacity = 1;
         *
         * // almost transparent teletext
         * stbPlayer.teletextOpacity = 0.1;
         */
        teletextOpacity: {
            get: function () {
                return _teletextOpacity;
            },
            set: function ( val ) {
                val = +val;
                if ( val >= 0 && val <= 255 ) {
                    gSTB.TeletextTransparency(val);
                    _teletextOpacity = val;
                }
            }
        },


        /**
         * Number (PID) of the current teletext track [0..0x1fff].
         *
         * This property should be accessed after the `event 9` occurs (see description of events).
         *
         * The list of all subtitles track determined by the player can be received with {@link stbPlayer.teletextTracks}.
         *
         * @type {number}
         */
        teletextPID: {
            get: function () {
                return gSTB.GetTeletextPID();
            },
            set: function ( val ) {
                gSTB.SetTeletextPID(val);
            }
        },

        /**
         * Get teletext viewport position and size.
         *
         * @type {viewportConfig}
         * @readonly
         */
        teletextViewport: {
            get: function () {
                return _teletextViewport;
            }
        },

        /**
         * Set path to folder where TimeShift files will be located.
         *
         * @see timeShift.SetTimeShiftFolder
         *
         * @type {string}
         */
        timeShiftFolder: {
            get: function () {
                return _timeShiftFolder;
            },
            set: function ( val ) {
                timeShift.SetTimeShiftFolder( val );
                _timeShiftFolder = val;
            }
        },


        /**
         * Set maximum size of TimeShift window in seconds.
         *
         * @see timeShift.SetMaxDuration
         *
         * @type {number}
         */
        timeShiftMaxDuration: {
            get: function () {
                return _timeShiftMaxDuration;
            },
            set: function ( val ) {
                timeShift.SetMaxDuration(val);
                _timeShiftMaxDuration = val;
            }
        },


        /**
         * Set sliding TimeShift mode which defines what happens after reaching the left boundary of TimeShift buffer in paused mode.
         *
         * By default sliding mode is disabled on start of each playback.
         *
         * @see timeShift.SetSlidingMode
         *
         * @type {boolean} possible values:
         *
         *  Value | Description
         * -------|-------------
         *  true  | Slide TimeShift buffer after overflow in paused mode. <br> `Event 36 (0x24)` will appear with code 3 in arguments. After that buffer continues writing to right boundary and drop all data from left boundary in paused mode.
         *  false | Do not slide after buffer overflow in pause mode. <br> `Event 36 (0x24)` will appear with code 4 in arguments. From this point we can play or seek inside current TimeShift buffer but right boundary will never grow until we switch into real-time mode.
         *
         * @default false
         */
        timeShiftSlidingMode: {
            get: function () {
                return _timeShiftSlidingMode;
            },
            set: function ( val ) {
                val = !!val;
                timeShift.SetSlidingMode(val);
                _timeShiftSlidingMode = val;
            }
        },
        /**
         * All available playing speed values for current media.
         * Collected with some delay after playback start.
         *
         * @type {number[]}
         * @readonly
         */
        speeds: {
            get: function () {
                return [0, 0.5, 0.25, 1, 2, 4, 8, 12, 16, 32, 64];
            }
        },


        audioPrimaryLanguage: {
            get: function () {
                return _audioPrimaryLanguage;
            },
            set: function ( val ) {
                gSTB.SetAudioLangs(val, _audioSecondaryLanguage);
                _audioPrimaryLanguage = val;
            }
        },
        audioSecondaryLanguage: {
            get: function () {
                return _audioSecondaryLanguage;
            },
            set: function ( val ) {
                gSTB.SetAudioLangs(_audioPrimaryLanguage, val);
                _audioSecondaryLanguage = val;
            }
        },
        subtitlesPrimaryLanguage: {
            get: function () {
                return _subtitlesPrimaryLanguage;
            },
            set: function ( val ) {
                gSTB.SetSubtitleLangs(val, _subtitlesSecondaryLanguage);
                _subtitlesPrimaryLanguage = val;
            }
        },
        subtitlesSecondaryLanguage: {
            get: function () {
                return _subtitlesSecondaryLanguage;
            },
            set: function ( val ) {
                gSTB.SetSubtitleLangs(_subtitlesPrimaryLanguage, val);
                _subtitlesSecondaryLanguage = val;
            }
        }
    });


    stbPlayerManager = {

        /**
         * Get array of all available stbPlayer instances in the system.
         *
         * @type {stbPlayer[]}
         * @readonly
         *
         * @example
         * // get player #0 instance
         * // and play some vide content
         * stbPlayerManager.list[0].play({...});
         * // is equivalent to legacy call
         * gSTB.Play(...);
         *
         * @example
         * // play video in another player
         * stbPlayerManager.list[1].play({...});
         */
        list: [stbPlayer],


        /**
         * Restore the default players state.
         */
        reset: function () {},


        /**
         * Switch two given players.
         * Affects geometry, sound, teletext and subtitles output.
         * Works only in case valid stbPlayer instances are provided.
         *
         * @param {stbPlayer} player1 first player instance to swap
         * @param {stbPlayer} player2 second player instance to swap
         *
         * @return {boolean} operation status
         *
         * @example
         * var p0 = stbPlayerManager.list[0],
         *     p1 = stbPlayerManager.list[1];
         *
         * // these two calls are equivalent
         * stbPlayerManager.swap(p0, p1);
         * stbPlayerManager.swap(p1, p0);
         */
        swap: function ( player1, player2 ) {},


        /**
         * Link to the player to be the default source of frame rate info.
         *
         * On set does not change value in case of a wrong given link.
         *
         * @type {stbPlayer}
         */
        autoFrameRateSource: stbPlayer,


        /**
         * Get current auto frame rate mode
         * that controls automatic switching frame rate mode of HDMI video output according to a content frame rate.
         *
         * @see stbPlayerManager.setAutoFrameRate
         *
         * @type {frameRateConfig}
         * @readonly
         */
        autoFrameRate: {
            fr24: false,
            fr50: false,
            fr60: false
        },


        /**
         * Apply options to automatically switch frame rate of HDMI video output according to a content frame rate.
         *
         * Auto frame rate switching works with `ffmpeg`, `file`, `ffrt2`, `ffrt3` solutions (if player has managed to detect frame rate of content)
         * and only on HDMI output in the following modes: 720p-50/60, 1080i-50/60 and 1080p-50/60. In 720p-50/60 modes player can switch only to 720p-50/60 modes.
         *
         * After stopping playback video output switches back to original frame rate.
         *
         * Warning: Not every TV supports 1080p-24 video mode.
         *
         * @see stbPlayerManager.autoFrameRate
         *
         * @param {frameRateConfig} config parameters to set
         *
         * @return {boolean} operation status
         *
         * @example
         * // enable switching to frame rates 24,50 and 60
         * stbPlayerManager.setAutoFrameRate({
                     *     fr24: true,
                     *     fr50: true,
                     *     fr60: true
                     * });
         *
         * // disable auto frame rate switching
         * stbPlayerManager.setAutoFrameRate({
                     *     fr24: false,
                     *     fr50: false,
                     *     fr60: false
                     * });
         */
        setAutoFrameRate: function ( config ) {
            var bitMask = (config.fr60 ? '1' : '0') + (config.fr50 ? '1' : '0') + (config.fr24 ? '1' : '0');

            config = config || {};

            this.autoFrameRate.fr24 = config.fr24 || false;
            this.autoFrameRate.fr50 = config.fr24 || false;
            this.autoFrameRate.fr60 = config.fr24 || false;
            console.log(parseInt(bitMask, 2));
            gSTB.SetAutoFrameRate(parseInt(bitMask, 2));

        },


        /**
         * Link to the player to be the default source of 3D converstion mode info.
         *
         * On set does not change value in case of a wrong given link.
         *
         * @type {stbPlayer}
         */
        '3DConversionModeSource': stbPlayer,


        /**
         * Get multicast current web proxy configuration.
         *
         * If multicast proxy configuration is set and multicast proxy enabled then any multicast `rtp://` or `udp://` stream
         * will be played back via multicast proxy e.i. instead of `rtp://239.1.1.1:1234`
         * player play the following stream: `[proxy_addr]/rtp/239.1.1.1:1234`.
         *
         * @see stbPlayerManager.setMulticastProxy
         * @see stbPlayerManager.resetMulticastProxy
         *
         * @type {proxyConfig}
         * @readonly
         *
         * @example
         * 'http://user1:pass1@16.16.16.16:3128'
         */
        multicastProxy: '',


        /**
         * Set multicast proxy configuration.
         *
         * Use {@link stbPlayerManager.multicastProxy} to get current proxy config options.
         *
         * @see stbPlayerManager.multicastProxy
         * @see stbPlayerManager.resetMulticastProxy
         *
         * @param {proxyConfig} proxy configuration options string
         *
         * @return {boolean} operation status
         *
         * @example
         * if ( stbPlayerManager.setMulticastProxy('http://16.16.16.16:3128') ) {
                     *     // proxy is applied and activated
                     * }
         */
        setMulticastProxy: function ( proxy ) {
            gSTB.SetMulticastProxyURL(proxy);
            this.multicastProxy = proxy;
            gSTB.EnableMulticastProxy(true);
        },


        /**
         * Disable sending all multicast requests through proxy.
         *
         * @see stbPlayerManager.multicastProxy
         * @see stbPlayerManager.setMulticastProxy
         */
        resetMulticastProxy: function () {
            gSTB.EnableMulticastProxy(false);
        },


        /**
         * Activate CAS with provided options.
         * {@link stbPlayerManager.setCASParams} should be called beforehand.
         *
         * @return {boolean} operation status
         *
         * @example
         * // set config options
         * stbPlayerManager.setCASParams({ ... });
         *
         * // activate
         * if ( !stbPlayerManager.activateCAS() ) {
                     *     console.log('CAS is not activated!');
                     * }
         */
        activateCAS: function () {
            var defaultParams = ['serverAddress', 'serverPort', 'companyName', 'opID', 'errorLevel', 'softDescrambling', 'iniFile'],
                otherParams = {},
                param;

            if ( casParams.serverAddress ) {
                gSTB.SetCASParam(casParams.serverAddress, casParams.serverPort, casParams.companyName, casParams.opID, casParams.errorLevel);
            }

            gSTB.SetCASDescrambling(casParams.softDescrambling ? 1 : 0);

            if ( casParams.iniFile ) {
                gSTB.LoadCASIniFile(casParams.iniFile);
            }

            for ( param in casParams ) {
                if (defaultParams.indexOf(param) < 0 ) {
                    otherParams[param] = casParams[param];
                }
            }

            Object.keys(otherParams).forEach(function (param) {
                gSTB.SetAdditionalCasParam(param, otherParams[param]);
            })

            gSTB.SetCASType(casParams.type);
        },


        /**
         * Set CAS server parameters.
         *
         * Call of the function can be done many times but becomes effective only if made before {@link stbPlayerManager.activateCAS}.
         *
         * @param {Object} params CAS parameters to set
         *
         * There is a set of predefined properties and it's also possible to specify some additional parameters.
         *
         * @param {number} params.type mandatory Conditional Access System type
         *
         * Should be set once after browser start. Possible type values:
         *
         *  Value | Description
         * -------|-------------
         *  0     | not set
         *  1     | Verimatrix
         *  2     | SecureMedia
         *  4-10  | custom CAS plugin with corresponding number
         *
         * @param {string} params.serverAddress CAS server address
         * @param {number} params.serverPort CAS server port
         * @param {string} params.companyName name of the company under which this operator is registered on CAS server
         * @param {number} params.operatorId operator identifier used by STB (if operator ID is equal to -1, the value is not updated)
         * @param {number} params.errorLevel level of error (0 – minimal level, if error level equals -1 it is not updated)
         * @param {string} params.iniFile address of the settings file in the root file system
         *
         * See instruction on adjusting CAS Verimatrix in the supplement.
         *
         * @param {boolean} [params.softDescrambling=true] hard or soft mode of descrambling
         *
         * At present  the use of this property is reasonable only for CAS Verimatrix.
         *
         * Depending on the mode set, the player can descramble only the streams scrambled by the following algorithm:
         *
         * - Soft mode: RC4, AES
         * - Hard mode: AES, DVB-CSA
         *
         * This mode is set only once after the start of the portal.
         *
         * @return {boolean} operation status
         *
         * @example
         * // set primary config options
         * stbPlayerManager.setCASParams({
                     *     type: 1,
                     *     serverAddress: 'some_server',
                     *     serverPort: 9999
                     * });
         *
         * // set additional config options
         * // can be merged with the first setCASParams call
         * stbPlayerManager.setCASParams({
                     *     errorLevel: 1,
                     *     softDescrambling: true,
                     *     additionalParameter1: 'value1',
                     *     additionalParameter2: 'value2'
                     * });
         *
         * // activate CAS with provided options
         * stbPlayerManager.activateCAS();
         */
        setCASParams: function ( params ) {
            var param;
            params = params || {};
            for ( param in params ) {
                casParams[param] = params[param];
            }
        },


        /**
         * Activate Web CAS with provided options.
         * {@link stbPlayerManager.setWebCASParams} should be called beforehand.
         *
         * @return {boolean} operation status
         *
         * @example
         * // set config options
         * stbPlayerManager.setWebCASParams({ ... });
         *
         * // activate
         * if ( !stbPlayerManager.activateWebCAS() ) {
                     *     console.log('Web CAS is not activated!');
                     * }
         */
        activateWebCAS: function () {
            gSTB.SetWebCASLogging(webCasParams.logging);
            gSTB.SetupWebCAS(webCasParams.serverAddress, webCasParams.companyName);

        },


        /**
         * Set Web CAS server parameters.
         *
         * Call of the function can be done many times but becomes effective only if made before {@link stbPlayerManager.activateWebCAS}.
         *
         * @param {Object} params Web CAS parameters to set
         * @param {string} params.serverAddress Web CAS server address (e.g. "verimatrix.com")
         * @param {string} [params.companyName] name of the company under which this operator is registered on CAS server
         * @param {boolean} params.logging enable/disable logging to file (turned off by default)
         *
         * File `/ram/data/vrweb_client.log` is used to store log data.
         * It's possible to read it with `gSTB.RDir('tempfile read vrweb_client.log')`.
         *
         * @return {boolean} operation status
         */
        setWebCASParams: function ( params ) {
            params = params || {};

            webCasParams.serverAddress = params.serverAddress;
            webCasParams.companyName   = params.companyName;
            webCasParams.logging       = params.logging;
        },


        /**
         * Get RTSP configuration.
         *
         * @type {RTSPConfig}
         * @readonly
         */
        RTSP: {
            endByAnnounce: false,
            endByGetParameter: false,
            endByRTP: false,
            endByTimeout: false,
            keepAlive: true,
            type: 0,
            useUDP: false
        },


        /**
         * Set client to STB.
         *
         * @param {RTSPConfig} config RTSP configuration options
         *
         * @return {boolean} operation status
         */
        setRTSP: function ( config ) {
            var type, flags;

            config = config || {};

            flags = (config.useUDP ? '1' : '0') + (config.endByRTP ? '1' : '0') + (config.endByTimeout? '1' : '0') + (config.endByGetParameter ? '1' : '0')
            + (config.endByAnnounce ? '1' : '0') + (config.keepAlive ? '1' : '0');

            flags = parseInt(flags, 2);

            type = config.type || 0;

            gSTB.SetupRTSP(type, flags);
        },


        /**
         * Set input buffer size for buffering support.
         *
         * Buffering works only with the following solutions: **ffmpeg**, **ffrt**, **ffrt2**, **ffrt3**, **fm**, **file**.
         *
         * After start of playback with mentioned above solution the following stages take place:
         *
         * - opening content for playback
         * - determining content information (raised `event 2` from List of the events used)
         * - input buffer filling stage
         * - after complete buffer filling stream data go to decoding
         * - decoded data go to outputs (raised `event 4` from List of the events used)
         *
         * @param {number} sizeInMs maximum buffer size in ms
         * @param {number} sizeInBytes maximum buffer size in bytes
         *
         * used **ONLY** to limit maximum amount of allocated memory but not as the primary buffer size
         *
         * @return {boolean} operation status
         */
        setBufferSize: gSTB.SetBufferSize
    };

    Object.defineProperties(stbPlayerManager, {
        /**
         * Current 3D conversion mode.
         *
         * Possible values:
         *
         *  Value | Description
         * -------|-------------
         *  0     | Treat video as normal 2D video. Default mode. In case of top-bottom or side-by-side 3D video player displays both stereo views so TV can reproduce 3D video (with half resolution). If TV is 3D capable and video contains information about 3D then TV will be automatically switched to 3D mode.
         *  1     | Treat video as 3D video in top-bottom(over-under) format with half resolution of each stereo view. In that mode player will stretch top half of the video into fullscreen according to specified aspect.
         *  2     | Treat video as 3D video in top-bottom(over-under) format with full resolution of each stereo view. In that mode player will stretch top half of the video into fullscreen according to specified aspect. The difference between STB_3D_MODE_TOP and STB_3D_MODE_TOP_HALF is that STB_SetAspect with other than auto mode gives different behaviour and in case of resulting video will be Full resolution HD.
         *  3     | Treat video as 3D video in side-by-side format with half resolution of each stereo view. In that mode player will stretch left half of the video into fullscreen according to specified aspect.
         *  4     | Same as STB_3D_MODE_FULL but without automatic TV switch to 3D.
         *
         * @type {number}
         */
        '3DConversionMode': {
            get: function () {
                return gSTB.Get3DConversionMode();
            },
            set: function ( val ) {
                gSTB.Set3DConversionMode(val);
            }
        },


        /**
         * Enable or disable SSL certificate checking while playing back HTTPS streams.
         *
         * @type {boolean}
         *
         * @default true
         */
        checkSSLCertificate: {
            get: function () {
                return _checkSSLCertificate;
            },
            set: function ( val ) {
                val = !!val;
                gSTB.SetCheckSSLCertificate(val ? 1 : 0);
                _checkSSLCertificate = val;
            }
        }
    });
    module.exports = stbPlayerManager;
}


/**
 * Get audio and subtitles tracks after event 2 fired
 */
function getMediaInfo () {
    // audio tracks
    try {
        stbPlayer.audioTracks = JSON.parse(gSTB.GetAudioPIDsEx().replace(/pid:/g, '\"pid\":').replace(/lang:/g, '\"lang\":').replace(/type:/g, '\"type\":').replace(/title:/g, '\"title\":').replace(/'/g,'"').replace(/,""/g, ''));
    } catch (e) { stbPlayer.audioTracks = []; }

    // subtitles tracks
    try {
        stbPlayer.subtitlesTracks = JSON.parse(gSTB.GetSubtitlePIDs().replace(/pid:/g, '\"pid\":').replace(/lang:/g, '\"lang\":').replace(/,""/g, ''));
    } catch (e) { stbPlayer.subtitlesTracks = []; }

    // get metadata info
    try {
        stbPlayer.metadataInfo = JSON.parse(gSTB.GetMetadataInfo());
    } catch (e) { stbPlayer.metadataInfo = null; }
}


/**
 * Get video info after event 7 fired
 */
function getVideoInfo () {
    try {
        debug.log('/////////////////////////', 'red');
        debug.inspect(gSTB.GetVideoInfo());
        stbPlayer.videoInfo = JSON.parse(
            gSTB.GetVideoInfo().replace(/frameRate:/g, '\"frameRate\":')
                .replace(/pictureWidth:/g, '\"width\":').replace(/pictureHeight:/g, '\"height\":')
                .replace(/hPAR:/g, '\"hPAR\":').replace(/vPAR:/g, '\"vPAR\":')
        );
    } catch (e) { stbPlayer.videoInfo = null; }
}
